import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
declare const Hls: any;
@Component({
  selector: 'app-image-preview',
  templateUrl: './image-preview.component.html',
  styleUrls: ['./image-preview.component.scss']
})

export class ImagePreviewComponent implements OnInit{

  @Input() public isAdvertisement;
  @Input() public materialAd;
  @Input() public url;
  @Output() public closeAd = new EventEmitter();
  timer: number = 10;

  constructor(
    private activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    if(this.isAdvertisement && this.materialAd && this.materialAd.label == 'image'){
      let timer = setInterval(() => {
        --this.timer;
        if(this.timer==0){
          clearInterval(timer);
          this.closeAd.emit(true);
        }
      }, 1000);
    }
  }

  closeDialog() {
    this.activeModal.close();
  }

}
